import actionCreatorFactory from 'typescript-fsa';
import { Outfit } from './outfits.reducer';
const actionCreator = actionCreatorFactory('Outfits');

export const updateOutfitEntities = actionCreator<{
  outfits: { [key: number]: Outfit };
  appId: number;
}>('ENTITIES_UPDATE');

export const updateOutfitEntitiesForAllLocales = actionCreator<{
  outfits: { [key: number]: Outfit };
  appIds: number[];
}>('ENTITIES_UPDATE_ALL_LOCALES');

export const fetchAutoSuggestOufit = actionCreator<{
  outfitId: number;
  appId: number;
}>('AUTOSUGGEST_FETCH');



// WEBPACK FOOTER //
// ./src/store/Entities/Outfits/outfits.actions.ts